var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import { Redirect } from 'react-router';
import gql from 'graphql-tag';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Query, Mutation } from 'react-apollo';
import { LoggedContext } from 'components/App';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
import { transformErrorToObject } from 'shared/error';
import { MEDIA_QUERIES } from 'shared/style';
import { Root } from './styled';
var RootDiv = styled(Root)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    width: 450px;\n    min-height: 330px;\n  }\n\n  > form {\n    &:not(:first-child) {\n      border-top: 1px solid #ddd;\n      padding-top: 30px;\n    }\n\n    > .element {\n      > .label {\n        width: 100px;\n      }\n      > .input {\n        ", " {\n          width: calc(100% - 100px - 20px - 10px);\n        }\n      }\n\n      > .text {\n        ", " {\n          width: 250px;\n        }\n        ", " {\n          width: calc(100% - 100px - 20px - 10px);\n        }\n        height: 50px;\n        padding: 13px 0 0 20px;\n        font-size: 16px;\n        border: 0;\n      }\n    }\n\n    > .error {\n      margin-left: 120px;\n    }\n\n    > .button-area {\n      margin-top: 30px;\n\n      > .login-button {\n        width: 150px;\n      }\n    }\n  }\n"], ["\n  ", " {\n    width: 450px;\n    min-height: 330px;\n  }\n\n  > form {\n    &:not(:first-child) {\n      border-top: 1px solid #ddd;\n      padding-top: 30px;\n    }\n\n    > .element {\n      > .label {\n        width: 100px;\n      }\n      > .input {\n        ", " {\n          width: calc(100% - 100px - 20px - 10px);\n        }\n      }\n\n      > .text {\n        ", " {\n          width: 250px;\n        }\n        ", " {\n          width: calc(100% - 100px - 20px - 10px);\n        }\n        height: 50px;\n        padding: 13px 0 0 20px;\n        font-size: 16px;\n        border: 0;\n      }\n    }\n\n    > .error {\n      margin-left: 120px;\n    }\n\n    > .button-area {\n      margin-top: 30px;\n\n      > .login-button {\n        width: 150px;\n      }\n    }\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE);
var GET_CURRENT_USER = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n{\n  currentUser {\n    id\n    email\n    name\n  }\n}\n"], ["\n{\n  currentUser {\n    id\n    email\n    name\n  }\n}\n"])));
var UPDATE_PASSWORD = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation UpdatePassword($email: String!, $password: String!) {\n    updatePassword(email: $email, password: $password)\n  }\n"], ["\n  mutation UpdatePassword($email: String!, $password: String!) {\n    updatePassword(email: $email, password: $password)\n  }\n"])));
var UPDATE_NAME = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  mutation UpdateName($email: String!, $name: String!) {\n    updateName(email: $email, name: $name)\n  }\n"], ["\n  mutation UpdateName($email: String!, $name: String!) {\n    updateName(email: $email, name: $name)\n  }\n"])));
var GET_USER_BY_NAME = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  query GetUserByName($name: String!) {\n    userByName(name: $name) {\n      id\n      name\n    }\n  }\n"], ["\n  query GetUserByName($name: String!) {\n    userByName(name: $name) {\n      id\n      name\n    }\n  }\n"])));
var Signup = /** @class */ (function (_super) {
    __extends(Signup, _super);
    function Signup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validateName = function (name, client) { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, client.query({
                            query: GET_USER_BY_NAME,
                            variables: { name: name },
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, !!(data.userByName && data.userByName.name)];
                }
            });
        }); };
        return _this;
    }
    Signup.prototype.render = function () {
        var _this = this;
        return (React.createElement(LoggedContext.Consumer, null, function (_a) {
            var logged = _a.logged;
            if (!logged) {
                return React.createElement(Redirect, { to: { pathname: '/ ' } });
            }
            return (React.createElement(RootDiv, null,
                React.createElement(Query, { query: GET_CURRENT_USER, fetchPolicy: "network-only" }, function (_a) {
                    var client = _a.client, data = _a.data, loading = _a.loading, error = _a.error;
                    if (loading)
                        return React.createElement(Loading, null);
                    if (error)
                        return React.createElement(Error, null);
                    var _b = data.currentUser, email = _b.email, name = _b.name;
                    return (React.createElement(React.Fragment, null,
                        React.createElement("form", null,
                            React.createElement("div", { className: "element" },
                                React.createElement("div", { className: "label" },
                                    React.createElement("label", { htmlFor: "email" }, "\uC774\uBA54\uC77C")),
                                React.createElement("div", { className: "text" }, email))),
                        React.createElement(Mutation, { mutation: UPDATE_PASSWORD }, function (updatePassword) { return (React.createElement(Formik, { initialValues: { password: '', repassword: '' }, validate: function (values) { return __awaiter(_this, void 0, void 0, function () {
                                var errors;
                                return __generator(this, function (_a) {
                                    errors = {};
                                    if (!values.password) {
                                        errors.password = '비밀번호를 입력해야 합니다.';
                                    }
                                    else if (values.password.length < 8) {
                                        errors.password = '비밀번호는 8자 이상이어야 합니다.';
                                    }
                                    if (!values.repassword) {
                                        errors.repassword = '확인을 위해 비밀번호를 다시 한번 입력해야 합니다.';
                                    }
                                    if (values.password
                                        && values.repassword
                                        && values.password !== values.repassword) {
                                        errors.repassword = '비밀번호가 일치하지 않습니다.';
                                    }
                                    if (Object.keys(errors).length) {
                                        throw errors;
                                    }
                                    return [2 /*return*/];
                                });
                            }); }, onSubmit: function (values, actions) {
                                updatePassword({ variables: __assign({}, values, { email: email }) }).then(function (_a) {
                                    var data = _a.data;
                                    actions.setSubmitting(false);
                                    alert('비밀번호가 정상적으로 변경되었습니다!');
                                }, function (err) {
                                    actions.setSubmitting(false);
                                    actions.setErrors(transformErrorToObject(err));
                                });
                            } }, function (_a) {
                            var isSubmitting = _a.isSubmitting;
                            return (React.createElement(Form, null,
                                React.createElement("div", { className: "element" },
                                    React.createElement("div", { className: "label" },
                                        React.createElement("label", { htmlFor: "password" }, "\uBE44\uBC00\uBC88\uD638")),
                                    React.createElement("div", { className: "input" },
                                        React.createElement(Field, { type: "password", name: "password" }))),
                                React.createElement(ErrorMessage, { name: "password", render: function (msg) { return React.createElement("div", { className: "error" }, msg); } }),
                                React.createElement("div", { className: "element" },
                                    React.createElement("div", { className: "label" },
                                        React.createElement("label", { htmlFor: "repassword" }, "\uBE44\uBC00\uBC88\uD638\uD655\uC778")),
                                    React.createElement("div", { className: "input" },
                                        React.createElement(Field, { type: "password", name: "repassword" }))),
                                React.createElement(ErrorMessage, { name: "repassword", render: function (msg) { return React.createElement("div", { className: "error" }, msg); } }),
                                React.createElement("div", { className: "button-area" },
                                    React.createElement("button", { type: "submit", className: "login-button" + (isSubmitting ? ' disabled' : ''), disabled: isSubmitting }, "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD"))));
                        })); }),
                        React.createElement(Mutation, { mutation: UPDATE_NAME, update: function (cache, _a) {
                                var updateName = _a.data.updateName;
                                var currentUser = cache.readQuery({ query: GET_CURRENT_USER }).currentUser;
                                cache.writeQuery({
                                    query: GET_CURRENT_USER,
                                    data: { currentUser: __assign({}, currentUser, { name: updateName }) }
                                });
                            } }, function (updateName) { return (React.createElement(Formik, { initialValues: { name: name }, validate: function (values) { return __awaiter(_this, void 0, void 0, function () {
                                var errors, existedName;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            errors = {};
                                            if (!!values.name) return [3 /*break*/, 1];
                                            errors.name = '닉네임을 입력해야 합니다.';
                                            return [3 /*break*/, 4];
                                        case 1:
                                            if (!(values.name.length < 2 || values.name.length > 8)) return [3 /*break*/, 2];
                                            errors.name = '닉네임은 2자 이상, 8자 이하여야 합니다.';
                                            return [3 /*break*/, 4];
                                        case 2: return [4 /*yield*/, this.validateName(values.name, client)];
                                        case 3:
                                            existedName = _a.sent();
                                            if (existedName) {
                                                errors.name = '이미 사용중인 닉네임입니다.';
                                            }
                                            _a.label = 4;
                                        case 4:
                                            if (Object.keys(errors).length) {
                                                throw errors;
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, onSubmit: function (values, actions) {
                                updateName({ variables: __assign({}, values, { email: email }) }).then(function () {
                                    actions.setSubmitting(false);
                                    alert('닉네임이 정상적으로 변경되었습니다.');
                                }, function (err) {
                                    actions.setSubmitting(false);
                                    actions.setErrors(transformErrorToObject(err));
                                });
                            } }, function (_a) {
                            var isSubmitting = _a.isSubmitting;
                            return (React.createElement(Form, null,
                                React.createElement("div", { className: "element" },
                                    React.createElement("div", { className: "label" },
                                        React.createElement("label", { htmlFor: "name" }, "\uB2C9\uB124\uC784")),
                                    React.createElement("div", { className: "input" },
                                        React.createElement(Field, { type: "text", name: "name" }))),
                                React.createElement(ErrorMessage, { name: "name", render: function (msg) { return React.createElement("div", { className: "error" }, msg); } }),
                                React.createElement("div", { className: "button-area" },
                                    React.createElement("button", { type: "submit", className: "login-button" + (isSubmitting ? ' disabled' : ''), disabled: isSubmitting }, "\uB2C9\uB124\uC784 \uBCC0\uACBD"))));
                        })); })));
                })));
        }));
    };
    return Signup;
}(React.Component));
export default Signup;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
